import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './AppRoutes'

import "react-range-slider-input/dist/style.css";
import './assets/css/animate.css'
import './assets/css/utilities.css'
import './assets/css/style.css'
import './assets/css/admin.css'
import './assets/css/responsive.css'

function App() {
  return (
    <BrowserRouter>
      <AppRoutes/>
    </BrowserRouter>
  );
}

export default App;
